export default {
  mounted() {
    const topLabelInput = document.getElementsByClassName("topLabel");

    topLabelInput.forEach(element => {
      element.addEventListener("focusin", event => {
        this.addFocus(event);
      });
      element.addEventListener("animationstart", event => {
        if (event.animationName === "onAutoFillStart") {
          this.addFocus(event);
        }
        if (event.animationName === "onAutoFillCancel") {
          this.removeFocus(event);
        }
      });
      element.addEventListener("focusout", event => {
        this.removeFocus(event);
      });
    });
  },

  methods: {
    addFocus: event => {
      event.target.classList.add("focused");
    },

    removeFocus: event => {
      if (event.target.classList.contains("focused") && event.target.value === "") {
        event.target.classList.remove("focused");
      }
    },
  },
};
